import type { ScriptOperation, ScriptProject } from '../../api/scripts';

export interface ScriptIntent {
  kind: 'preview' | 'render' | 'revoice';
  key: string;
  revision: number;
  price: number;
  lineKey?: string;
  orderId?: number;
  resultRevision?: number;
  operation?: ScriptOperation;
  previous?: ScriptOperation;
  uncertainRequest?: boolean;
  snapshot: ScriptProject;
}
export type ScriptIntents = Record<string, ScriptIntent>;
export const scriptIntentSlot = (kind: ScriptIntent['kind'], lineKey?: string) => (kind === 'preview' ? `preview:${lineKey}` : 'render');
const storageKey = (owner: number, project: number) => `steos:script:operations:${owner}:${project}`;

export function readScriptIntents(owner: number, project: number): ScriptIntents {
  const raw = sessionStorage.getItem(storageKey(owner, project));
  if (!raw) return {};
  const parsed: unknown = JSON.parse(raw);
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) throw new Error('script_intent_invalid');
  const result: ScriptIntents = {};
  for (const [slot, value] of Object.entries(parsed)) {
    const intent = value as ScriptIntent;
    if (
      !intent ||
      !['preview', 'render', 'revoice'].includes(intent.kind) ||
      !/^[0-9a-f-]{36}$/i.test(intent.key) ||
      intent.snapshot?.id !== project ||
      !Number.isSafeInteger(intent.revision) ||
      intent.revision < 1 ||
      !Number.isFinite(intent.price) ||
      intent.price <= 0 ||
      slot !== scriptIntentSlot(intent.kind, intent.lineKey)
    )
      throw new Error('script_intent_invalid');
    if (intent.operation && (intent.operation.project_id !== project || !/^[0-9a-f-]{36}$/i.test(intent.operation.operation_id)))
      throw new Error('script_intent_invalid');
    result[slot] = intent;
  }
  return result;
}

/** Ключ и снимок фиксируются до платного POST; ошибка хранилища запрещает новый эффект. */
export function writeScriptIntents(owner: number, project: number, intents: ScriptIntents) {
  sessionStorage.setItem(storageKey(owner, project), JSON.stringify(intents));
}
export const scriptOperationPending = (intent?: ScriptIntent) =>
  !!intent && (!intent.operation || ['queued', 'processing', 'uncertain'].includes(intent.operation.status));
